import { useTranslation } from 'react-i18next'

import { EMPTY_STRING } from '../../../constants/common'
import { TableCellText } from '../TableCellText'

function TableCellNumber({ ref, value, valuePrefix, ...textProps }) {
  const { t } = useTranslation()

  const textValue = value
    ? `${valuePrefix ? `${t(valuePrefix)} ` : EMPTY_STRING}${value}`
    : null

  return <TableCellText {...textProps} ref={ref} value={textValue} />
}

export default TableCellNumber
